import { twMerge } from 'tailwind-merge';

interface NotFoundProps {
  text: string | React.ReactNode;
  containerClassName?: string;
  icon?: React.ReactNode;
  iconClassName?: string;
  textClassName?: string;
}

export const NotFound = ({
  text,
  containerClassName,
  icon,
  iconClassName,
  textClassName,
}: NotFoundProps) => {
  return (
    <div className={twMerge('flex justify-center gap-2.5', containerClassName)}>
      {icon || (
        <i
          className={twMerge(
            '-mt-1.5 ki-filled ki-information-2 text-danger text-2xl',
            iconClassName
          )}
        />
      )}
      <h3
        className={twMerge(
          'text-md text-red-FF2929 font-medium leading-tight',
          textClassName
        )}
      >
        {text}
      </h3>
    </div>
  );
};
